import { RootState } from '../store';
import { CheckoutState } from './checkout.slice';

export const selectCheckoutState = (state: RootState): CheckoutState => state.checkout;
